import { PLAYBACK_RATES, type PlaybackRate } from './player.types';
import styles from './SpeedSelector.module.css';

interface SpeedSelectorProps {
  onChange: (rate: PlaybackRate) => void;
  /** Why the speed cannot be changed yet, while the player loads. */
  unavailableReason?: string;
  value: PlaybackRate;
}

export function SpeedSelector({
  onChange,
  unavailableReason,
  value,
}: SpeedSelectorProps) {
  return (
    <div className={styles.wrapper}>
      <select
        aria-disabled={unavailableReason ? 'true' : undefined}
        aria-label="Playback speed"
        className={styles.select}
        onChange={(event) => {
          // The choice stays where it was: the value is the player's.
          if (!unavailableReason) {
            onChange(Number(event.currentTarget.value) as PlaybackRate);
          }
        }}
        title={unavailableReason}
        value={value}
      >
        {PLAYBACK_RATES.map((rate) => (
          <option key={rate} value={rate}>
            {rate}x
          </option>
        ))}
      </select>
    </div>
  );
}
